import { Reducer } from 'react';
import { ITableColumns, TemplateTableAction, TemplateTableState } from './types';
import { questionsTableColumn } from './config';
import {
  addAllPageItems,
  addSelected,
  removeAllSelectedItems,
  removeSelected
} from '../Components/GenericTable/tableHelper';

export const InitialTemplateTableState: TemplateTableState<ITableColumns> = {
  snackbar: {
    message: '',
    state: 'success'
  },
  modalsOpen: null,
  templateTableState: {
    canScroll: [false, true],
    tableHovered: false,
    density: 'Default',
    columns: questionsTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {
        delete: false,
        edit: false
      }
    },
    modalsOpen: { edit: false }
  },
  templateTableSettings: {
    page: Number(sessionStorage.getItem(`questionsTablePage`)) || 1,
    limit: 10,
    sort: 'name',
    sort_order: 'asc'
  },
  searchQuery: ''
};

export const TemplateTableReducer: Reducer<
  TemplateTableState<ITableColumns>,
  TemplateTableAction
> = (state: TemplateTableState<ITableColumns>, action: TemplateTableAction) => {
  switch (action.type) {
    case 'CHANGE_TABLE_TAB':
      return {
        ...state,
        templateTableState: { ...state.templateTableState, columns: action.payload }
      };
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_MODALS_OPEN':
      return { ...state, modalsOpen: action.payload };
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: action.payload,
        templateTableState: {
          ...state.templateTableState,
          selectedItemIds: [],
          selectedItems: []
        }
      };
    case 'SET_CAN_SCROLL':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          canScroll: action.payload
        }
      };
    case 'SET_TABLE_HOVERED':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          tableHovered: action.payload
        }
      };
    case 'SET_SORT':
      return {
        ...state,
        templateTableSettings: {
          ...state.templateTableSettings,
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        },
        templateTableState: {
          ...state.templateTableState,
          selectedItemIds: [],
          selectedItems: []
        }
      };
    case 'SET_PAGE':
      return {
        ...state,
        templateTableSettings: {
          ...state.templateTableSettings,
          page: action.payload
        },
        templateTableState: {
          ...state.templateTableState,
          selectedItemIds: [],
          selectedItems: []
        }
      };
    case 'SET_LIMIT':
      return {
        ...state,
        templateTableSettings: {
          ...state.templateTableSettings,
          limit: action.payload
        },
        templateTableState: {
          ...state.templateTableState,
          selectedItemIds: [],
          selectedItems: []
        }
      };
    case 'SELECT_ACTION_ITEM':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          actions: {
            ...state.templateTableState.actions,
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: {
              ...state.templateTableState.actions.isOpen,
              [action.payload.name]: true
            }
          }
        }
      };
    case 'CLOSE_ACTION_ITEM':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          actions: {
            ...state.templateTableState.actions,
            selectedItem: null,
            isOpen: {
              ...state.templateTableState.actions.isOpen,
              [action.payload]: false
            },
            anchorEl: null
          }
        }
      };
    case 'ADD_SELECTED_ITEM':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          ...addSelected(
            state.templateTableState.selectedItems,
            state.templateTableState.selectedItemIds,
            action.payload
          )
        }
      };
    case 'REMOVE_SELECTED_ITEM':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          ...removeSelected(
            state.templateTableState.selectedItems,
            state.templateTableState.selectedItemIds,
            action.payload
          )
        }
      };
    case 'ADD_ALL_PAGE_ITEMS':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          ...addAllPageItems(state.templateTableState.selectedItems, action.payload)
        }
      };
    case 'REMOVE_ALL_PAGE_ITEMS':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          ...removeAllSelectedItems(
            state.templateTableState.selectedItems,
            state.templateTableState.selectedItemIds
          )
        }
      };
    case 'CLEAR_SELECTED_ITEMS':
      return {
        ...state,
        templateTableState: {
          ...state.templateTableState,
          selectedItemIds: [],
          selectedItems: []
        }
      };
    default:
      return state;
  }
};
